<template>
  <div class="spaceLeft pool-status" :class="{
    success: +statusRearly == 2,
    failed: +statusRearly == 3,
    ing: +statusRearly == 1
  }">
    <img src="@/assets/image/governance/polling-icon-1.png" v-if="+statusRearly == 2" />
    <img src="@/assets/image/governance/polling-icon-2.png" v-if="+statusRearly == 3" />
    <span class="pool-status-text">{{
      statusMap["status_" + statusRearly]
    }}</span>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: [String, Number],
      default: () => {
        return 1
      }
    },
    over: {
      type: [Number, String]
    },
    cumulative: {
      type: [Number, String]
    },
    threshold: {
      type: [Number, String]
    }
  },
  data() {
    return {
      statusMap: this.$store.getters.voteStatusMap
    };
  },
  computed: {
    statusRearly() {
      let now = parseInt(new Date().getTime() / 1000);
      let cum = new this.BigNumber(this.cumulative);
      let th = new this.BigNumber(this.threshold);
      // if(this.over <= now && cum.comparedTo(th) < 0 && this.status == 1){
      //   return 3;
      // }
      // else if(this.status == 2){
      //   return 2;
      // }
      // else if(this.over > now && this.status == 1){
      //   return 1;
      // }
      // else{
      //   return 3;
      // }

      if ([0, 1].includes(this.status)) {
        return 1;
      }
      else if ([4, 5, 7, 8].includes(this.status)) {
        return 2;
      }
      else if ([2, 3, 6].includes(this.status)) {
        return 3;
      }
      else {
        return 3;
      }

    }
  },
  methods: {},
  created() { },
  watch: {}
};
</script>
<style scoped lang="scss">
.pool-status {
  margin-left: 0.13rem;
  font-size: 0.18rem;

  .pool-status-text {
    color: #fff;
    font-size: 0.16rem;
    padding: 0.04rem 0.07rem 0.04rem 0.2rem;
    border-radius: 0.04rem;
    position: relative;
    left: -0.16rem;
    z-index: 1;
    line-height: 0.24rem;
  }

  &.success .pool-status-text {
    background: #3172fd;
  }

  &.failed .pool-status-text {
    background: #929dad;
  }

  &.ing {
    background: url("../../../assets/image/governance/polling-icon-bg.png") no-repeat;
    background-size: 100% 100%;
    color: #fff;
  }

  img {
    height: 0.32rem;
    position: relative;
    z-index: 2;
  }
}
</style>
